import { render, staticRenderFns } from "./file-manager.vue?vue&type=template&id=56535d8a&"
import script from "./file-manager.vue?vue&type=script&lang=js&"
export * from "./file-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports